import { render, staticRenderFns } from "./ThreadHistoryList.vue?vue&type=template&id=4c05c4d4&"
import script from "./ThreadHistoryList.vue?vue&type=script&lang=js&"
export * from "./ThreadHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports